export const getStyles = (components, { palette = {} } = {}) => {
  const color = {
    completedBorder: palette.blue,
    completedIcon: palette.blue,
    inProgressIcon: '#c0def6',
    incompleteBorder: '#ebebeb',
    incompleteIcon: palette.neutralLight,
    background: palette.white,
    stepContentBorder: palette.neutralQuaternaryAlt,
    stepFooterBorder: palette.neutralLight,
  };
  return ({
    conversionWizard: {
      flexDirection: 'column',
      float: '1 0 auto',
      height: '100%',
      width: '100%',
      display: 'flex',
      '& .react-block-ui, & .react-block-ui-none': { height: '100%', width: '100%' },
      '& .step-footer-buttons': {
        marginLeft: '-8px',
      },
    },

    // StepProgressList on left side
    wizardListContainer: {
      width: '228px',
      minWidth: '228px',
      borderRight: `1px solid ${color.stepContentBorder}`,
      paddingLeft: '32px',
      paddingTop: '32px',
      paddingBottom: '32px',
      overflow: 'hidden',
      minHeight: 450,

      '& ol': {
        margin: 0,
        padding: 0,
        listStyle: 'none',
      },

      // Styles for drawing the vertical line
      '& .step-progress-list-item': {
        borderLeft: `2px solid ${color.completedBorder}`,
        '&.step-progress-list-item-ahead': { borderLeftColor: color.incompleteBorder },
      },

      // top level list items
      '& ol.step-progress-list>.step-progress-list-item': {
        paddingTop: '24px',

        '&:first-child': { borderLeftColor: color.background, paddingTop: 0 },

        '&>.step-progress-list-item-glyphicon': {
          marginLeft: '-8px',
          marginRight: '8px',
          background: color.background,
          paddingTop: '5px',
          paddingBottom: '4px',
        },

        '&>.step-progress-list-item-glyphicon.iconba-RadioBullet2': {
          paddingTop: 0,
          paddingBottom: 0,
          transform: 'scale(1.52)',
        },
      },

      // nested list items
      '& ol.step-progress-list-item-list>.step-progress-list-item': {
        fontSize: '12px',
        lineHeight: '16px',
        paddingTop: '24px',
        marginLeft: '-2px',

        '&>.step-progress-list-item-glyphicon': {
          marginLeft: '-8px',
          marginRight: '12px',
          background: color.background,
          paddingBottom: '1px',
        },
      },

      '& .step-progress-list-item-selected, & .step-progress-list-item-contains-selected': { fontWeight: '600' },

      // glyphicon colors
      '& .step-progress-list-item-behind .step-progress-list-item-glyphicon': {
        color: color.completedIcon,
      },
      '& .step-progress-list-item-selected .step-progress-list-item-glyphicon, & .step-progress-list-item-contains-selected>.step-progress-list-item-glyphicon': {
        color: color.inProgressIcon,
      },
      '& .step-progress-list-item-ahead .step-progress-list-item-glyphicon': {
        color: color.incompleteIcon,
      },
    },

    // Content area on right side
    wizardContentContainer: {
      display: 'flex',
      minWidth: 550,
      height: '100%',

      '& .step-container, & .step, & .step>div': { height: '100%', width: '100%' },

      // validation errors
      '& .error': {
        fontSize: '12px',
        lineHeight: '16px',
        color: '#a80000',
      },
    },
  });
};

